export function libsSharedServices(): string {
  return 'libs/shared-services';
}
